export default "__VITE_ASSET__gsfjHH69__"